import { apiClient } from '@/lib/api/client';

export interface WaitlistFormValues {
  email: string;
  source: string;
  captchaToken: string;
  honeypot: string;
}

export type WaitlistSubmitResult = { ok: true } | { ok: false; error: string };

export const WAITLIST_SEND_FAILED =
  'Could not request early access. Please try again.';

export async function submitWaitlist(
  values: WaitlistFormValues
): Promise<WaitlistSubmitResult> {
  if (values.honeypot.trim() !== '') {
    return { ok: true };
  }

  try {
    const { error, response } = await apiClient.POST('/api/v1/waitlist', {
      body: {
        email: values.email,
        source: values.source,
        captchaToken: values.captchaToken,
        website: values.honeypot,
      },
    });

    if (!error && response.ok) {
      return { ok: true };
    }
  } catch {
    return { ok: false, error: WAITLIST_SEND_FAILED };
  }

  return { ok: false, error: WAITLIST_SEND_FAILED };
}
